import { useMemo } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Props = {
  label?: string;
  archived?: boolean;
  hidden?: boolean;
  disabled?: boolean;
};

export const DropdownOptionLabel = ({ label = '', archived = false, hidden = false, disabled = false }: Props) => {
  const labelColor = useMemo(() => {
    if (archived || hidden) return 'subdued';
    if (disabled) return 'disabled';
    return 'default';
  }, [archived, hidden, disabled]);

  return (
    <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
      {archived && <Icon name='archive-small' color='subdued' css={{ flexShrink: 0 }} />}
      <Text as='span' color={labelColor} css={tooltipStyle}>
        {label}
      </Text>
    </div>
  );
};

const tooltipStyle = css`
  [role='tooltip'] & {
    color: inherit;
  }
`;
